import { render } from "./InputUpload.vue?vue&type=template&id=b89e4642&scoped=true"
import script from "./InputUpload.vue?vue&type=script&lang=js"
export * from "./InputUpload.vue?vue&type=script&lang=js"

import "./InputUpload.vue?vue&type=style&index=0&id=b89e4642&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89e4642"]])

export default __exports__